import { addDays, isAfter, isBefore, isValid, subYears } from 'date-fns';

export class ValidateUtils {
  static isValidDate = (date: string) => (date && isValid(new Date(date))) || 'Invalid date';

  static isAdult = (date: string) => {
    const birthDate = new Date(date);
    const minAdultDate = subYears(new Date(), 18);
    return (isValid(birthDate) && isBefore(birthDate, minAdultDate)) || 'The age should be over 18 years';
  };

  static isFutureDate = (date: string) => {
    const expiryDate = new Date(date);
    const tomorrow = addDays(new Date(), 1);
    return (isValid(expiryDate) && isAfter(expiryDate, tomorrow)) || 'The passport/ID should be valid';
  };
}
